import React from "react";
import { LanguageProvider } from "./context/LanguageContext";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ImpactCounters from "./components/ImpactCounters";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import FinancialToolsSection from "./components/FinancialToolsSection";
import FinancialQuiz from "./components/FinancialQuiz";
import ProjectsSection from "./components/ProjectsSection";
import LecturesSection from "./components/LecturesSection";
import ContentSection from "./components/ContentSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ConstructionPage from "./components/ConstructionPage";
import "./styles/design-system.css";

const LandingPage = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      <Header />
      <main>
        <HeroSection />
        <ImpactCounters />
        <AboutSection />
        <ServicesSection />
        <FinancialToolsSection />
        <FinancialQuiz />
        <ProjectsSection />
        <LecturesSection />
        <ContentSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: {
            fontFamily: 'Inter, sans-serif'
          }
        }}
      />
      <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/em-construcao" element={<ConstructionPage />} />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
